
export const images = [
    {
        src: "gallery/Collab-4.jpg"
    },
    {
        src: "gallery/Collab-PinkSuit-32.jpg",
        
    },
    {
        src: "gallery/divider-3.jpg",
        
    },
    {
        src: "gallery/divider-4.jpg",
        
    },
    {
        src: "gallery/divider-1.jpg",
        
    },
    {
        src: "gallery/divider-2.jpg",
        
    },
    {
        src: "gallery/Collab-PinkSuit-33.jpg",
        
    },
    {
        src: "gallery/Collab-PinkSuit-19.jpg",
        
    },
    {
        src: "gallery/pink-divider.jpg",
    },
    {
        src: "gallery/white-divider.jpg",
    }
    
]
